import React, { useContext, useEffect, useState } from 'react'
import './singlecategory.css'
import AdminNavbar from '../../admin-components/admin-nav/AdminNavbar'
import AdminBottomNav from '../../admin-components/adminbottomnav/AdminBottomNav'
import { useLocation } from 'react-router'
import axios from 'axios'
import { Context } from '../../context/Context';
import { useHistory } from 'react-router-dom'

function SingleCategory() {

    const api_uri = "https://mentorxfa.herokuapp.com/api";   
    const location = useLocation()
    const {user} = useContext(Context);
    const path = location.pathname.split("/")[3];
    const [cat, setCat] = useState({});
    const [name, setName] = useState("");
    const [updateMode, setUpdateMode] = useState(false);

    const history = useHistory();

    useEffect(() => {
        const getPost = async () => {
            const res = await axios.get(api_uri+"/categories/"+path);
            setCat(res.data);
         
            setName(res.data.name)                 
        }
        getPost();   
    }, [path])

    const handleUpdate = async () =>{
        try {            
            await axios.put(api_uri+`/categories/${cat._id}`, {     
                name,
                role: user.role
            });
            setUpdateMode(false);
        } catch (err) {
            console.log(err);
        }
    }

    const handleDelete = async () => {
        try {            
            await axios.delete(api_uri+`/categories/${cat._id}`, {
                data: {role: user.role},
            });     
            setTimeout(() => {
                history.push("/admin/categories")
            }, 250)  
        } catch (err) {
            console.log(err);
        }
    }

    return (
        <>
        <AdminNavbar/>
        <div className="single-category">
            {
                !updateMode ?
                <div className="single-category-display">
                <h3 className="single-category-name">
                   {name}
                </h3>
                <div className="single-category-edit">
                    <i className="single-post-icon far fa-edit" onClick={()=>setUpdateMode(true)} ></i>
                    <i className="single-post-icon far fa-trash-alt" onClick={handleDelete} ></i>
                </div> 
            </div>  :
            <div className="single-category-update">
            <input type="text" required value={name}  onChange={e => setName(e.target.value)}   className="single-category-input" placeholder="Name" />
                <div className="single-category-btns">
                    <button className="category-update-btn" onClick={handleUpdate}>Update</button>       
                    <button className="category-cancel-btn" onClick={()=>setUpdateMode(false)}>Cancel</button>
                </div> 
            </div>
            }
        </div>
        <AdminBottomNav/>
        </>
    )
}

export default SingleCategory
